module.exports = __webpack_public_path__ + "RobotoRegular.c251874b71d7fa27e266.woff2";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoRegular.woff2
// module id = ../../../../../src/fonts/RobotoRegular.woff2
// module chunks = 3